import React from "react";
import { useSelector } from "react-redux";
import Window from "./Window";
import { selectWindows } from "../../Slices/windowsSlice";

/**
 * WindowLayer — renders every open window from the windowsSlice.
 *
 * Content is delegated to `renderContent(win)` so this layer stays generic:
 *  - Phase 2 (preview): a placeholder is rendered.
 *  - Phase 4: `renderContent` returns the real per-window screen (MemoryRouter).
 *
 * Windows are absolutely positioned inside their stage container, so this
 * component renders them as a flat list (no wrapper) — the parent's
 * `.webtop-stage` is the positioning context.
 */

const DefaultPlaceholder = ({ win }) => (
  <div className="webtop-placeholder">
    <h3>{win.title}</h3>
    <p>This window will host its real screen in Phase 4.</p>
    <code>{win.path}</code>
  </div>
);

const WindowLayer = ({ renderContent }) => {
  const windows = useSelector(selectWindows);

  return (
    <>
      {windows.map((win) => (
        <Window key={win.id} win={win}>
          {renderContent ? renderContent(win) : <DefaultPlaceholder win={win} />}
        </Window>
      ))}
    </>
  );
};

export default WindowLayer;
